// HKDSE 2025 Paper 1 Knowledge Graph Samples - Part 2
// Continuing with remaining questions from the LaTeX file

export const hkdse2025Samples_part2 = {
  coordinate_geometry: [
    {
      id: 'hkdse2025_coordinate_geometry_02',
      problem: "点 $A$ 的坐标为 $(4, -2)$。$A$ 绕原点 $O$ 顺时针方向旋转 $90°$ 至 $B$。(a) 写出 $B$ 的坐标。(b) 假定 $B$ 向上平移 $t$ 单位至点 $C$。若 $A$、$O$ 与 $C$ 共线，求 $t$。",
      problemType: "coordinate_geometry_rotation_translation",
      difficulty: "intermediate",
      description: "Working with rotation and translation in coordinate geometry",
      graphData: {
        nodes: [
          {
            id: "rotation_90_clockwise",
            name: "90° Clockwise Rotation",
            type: "concepts",
            description: "Rotation matrix for 90° clockwise about origin",
            value: "(x,y) → (y,-x)",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "point_a_coordinates",
            name: "Point A Coordinates",
            type: "variables",
            description: "Original point coordinates",
            value: "A(4, -2)",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "step1_rotate_point_a",
            name: "Step 1: Rotate Point A",
            type: "steps",
            description: "Apply rotation to find B coordinates",
            value: "B(-2, -4)",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "translation_upward",
            name: "Translation Upward",
            type: "concepts",
            description: "Moving point B upward by t units",
            value: "C(-2, -4 + t)",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "collinearity_condition",
            name: "Collinearity Condition",
            type: "concepts",
            description: "Three points are collinear if slopes are equal",
            value: "Slope OA = Slope OC",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "step2_calculate_slopes",
            name: "Step 2: Calculate Slopes",
            type: "steps",
            description: "Calculate slopes of OA and OC",
            value: "Slope OA = -2/4 = -1/2, Slope OC = (-4+t)/(-2)",
            importance: 8,
            x: -200, y: 200, z: 0
          },
          {
            id: "step3_solve_equation",
            name: "Step 3: Solve Equation",
            type: "steps",
            description: "Set slopes equal and solve for t",
            value: "-1/2 = (-4+t)/(-2) → t = 5",
            importance: 9,
            x: 200, y: 200, z: 0
          },
          {
            id: "final_answers",
            name: "Final Answers",
            type: "values",
            description: "Coordinates of B and value of t",
            value: "(a) B(-2, -4) (b) t = 5",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "rotation_90_clockwise", to: "step1_rotate_point_a", type: "enables", strength: 10 },
          { from: "point_a_coordinates", to: "step1_rotate_point_a", type: "provides_data", strength: 9 },
          { from: "step1_rotate_point_a", to: "translation_upward", type: "enables", strength: 8 },
          { from: "translation_upward", to: "collinearity_condition", type: "enables", strength: 9 },
          { from: "collinearity_condition", to: "step2_calculate_slopes", type: "leads_to", strength: 9 },
          { from: "step2_calculate_slopes", to: "step3_solve_equation", type: "leads_to", strength: 9 },
          { from: "step1_rotate_point_a", to: "final_answers", type: "contributes_to", strength: 9 },
          { from: "step3_solve_equation", to: "final_answers", type: "contributes_to", strength: 10 }
        ]
      }
    }
  ],
  
  geometry: [
    {
      id: 'hkdse2025_geometry_02',
      problem: "图中，$ST$ 与 $UY$ 相交于点 $W$。已知 $SU \\parallel VT$ 及 $W$ 为 $ST$ 的中点。Figure description: A geometric diagram showing two intersecting lines ST and UY meeting at point W. There are additional points S, T, U, V forming what appears to be a geometric configuration where SU is parallel to VT and W is the midpoint of ST. (a) 证明 $\\triangle SUW \\cong \\triangle TVW$。(b) 设 $X$ 为 $TW$ 上的一点使得 $\\triangle SUW \\sim \\triangle VXW$。若 $SU = 57$ cm，$SW = 63$ cm 及 $WX = 7$ cm，求 $\\triangle TVX$ 的周界。",
      problemType: "geometry_congruence_similarity",
      difficulty: "intermediate",
      description: "Working with congruent and similar triangles",
      graphData: {
        nodes: [
          {
            id: "intersecting_lines",
            name: "Intersecting Lines",
            type: "concepts",
            description: "ST and UY intersect at W",
            value: "ST ∩ UY = W",
            importance: 9,
            x: 0, y: -200, z: 0
          },
          {
            id: "parallel_lines",
            name: "Parallel Lines",
            type: "concepts",
            description: "SU parallel to VT",
            value: "SU ∥ VT",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "midpoint_property",
            name: "Midpoint Property",
            type: "concepts",
            description: "W is midpoint of ST",
            value: "SW = WT",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_a_congruence_proof",
            name: "Part (a): Congruence Proof",
            type: "steps",
            description: "Prove triangles are congruent",
            value: "Use SAS or ASA criteria",
            importance: 9,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_b_similarity_ratio",
            name: "Part (b): Similarity Ratio",
            type: "steps",
            description: "Find ratio of similar triangles",
            value: "SU/VX = SW/WX = 63/7 = 9",
            importance: 8,
            x: -200, y: 200, z: 0
          },
          {
            id: "part_b_find_vx",
            name: "Part (b): Find VX",
            type: "steps",
            description: "Calculate VX using similarity",
            value: "VX = SU/9 = 57/9 = 6.33 cm",
            importance: 8,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_perimeter_calculation",
            name: "Part (b): Perimeter Calculation",
            type: "steps",
            description: "Calculate perimeter of triangle TVX",
            value: "Perimeter = TV + VX + XT",
            importance: 9,
            x: 200, y: 200, z: 0
          },
          {
            id: "final_answer",
            name: "Final Answer",
            type: "values",
            description: "Perimeter of triangle TVX",
            value: "Perimeter = calculated value in cm",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "intersecting_lines", to: "part_a_congruence_proof", type: "enables", strength: 9 },
          { from: "parallel_lines", to: "part_a_congruence_proof", type: "enables", strength: 9 },
          { from: "midpoint_property", to: "part_a_congruence_proof", type: "enables", strength: 8 },
          { from: "part_a_congruence_proof", to: "part_b_similarity_ratio", type: "enables", strength: 8 },
          { from: "part_b_similarity_ratio", to: "part_b_find_vx", type: "leads_to", strength: 8 },
          { from: "part_b_find_vx", to: "part_b_perimeter_calculation", type: "enables", strength: 9 },
          { from: "part_b_perimeter_calculation", to: "final_answer", type: "leads_to", strength: 10 }
        ]
      }
    }
  ],
  
  statistics: [
    {
      id: 'hkdse2025_statistics_01',
      problem: "下表显示一些学生拥有原子笔的数目的分佈。Table description: A frequency distribution table with two rows: Row 1 (header): 原子笔的数目 | 5 | 6 | 7 | 8 | 9; Row 2: 学生人数 | 9 | 13 | 2 | s | 11. 该分佈的中位数为 $7$。(a) 求 $s$ 的最小可取值。(b) 写出 $s$ 的最大可取值。(c) 求该分佈的最大可取标准差。",
      problemType: "statistics_frequency_distribution",
      difficulty: "intermediate",
      description: "Analyzing frequency distribution with median condition",
      graphData: {
        nodes: [
          {
            id: "frequency_table",
            name: "Frequency Table",
            type: "concepts",
            description: "Distribution of pens: 5(9), 6(13), 7(2), 8(s), 9(11)",
            value: "Total students = 35 + s",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "median_condition",
            name: "Median Condition",
            type: "concepts",
            description: "Median is 7",
            value: "Median = 7",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "part_a_minimum_s",
            name: "Part (a): Minimum s",
            type: "steps",
            description: "Find minimum value of s for median to be 7",
            value: "Need enough students in 8+ categories",
            importance: 8,
            x: 200, y: 0, z: 0
          },
          {
            id: "part_a_calculation",
            name: "Part (a): Calculation",
            type: "steps",
            description: "Calculate minimum s",
            value: "s ≥ 1",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "part_b_maximum_s",
            name: "Part (b): Maximum s",
            type: "steps",
            description: "Find maximum value of s",
            value: "s ≤ 10",
            importance: 8,
            x: -200, y: 200, z: 0
          },
          {
            id: "part_c_standard_deviation",
            name: "Part (c): Standard Deviation",
            type: "steps",
            description: "Calculate maximum possible standard deviation",
            value: "Use formula σ = √[Σ(x-μ)²f/Σf]",
            importance: 9,
            x: 200, y: 200, z: 0
          },
          {
            id: "final_answers",
            name: "Final Answers",
            type: "values",
            description: "All required values",
            value: "(a) s ≥ 1 (b) s ≤ 10 (c) σ = calculated value",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "frequency_table", to: "median_condition", type: "enables", strength: 9 },
          { from: "median_condition", to: "part_a_minimum_s", type: "enables", strength: 8 },
          { from: "part_a_minimum_s", to: "part_a_calculation", type: "leads_to", strength: 8 },
          { from: "part_a_calculation", to: "part_b_maximum_s", type: "enables", strength: 8 },
          { from: "part_b_maximum_s", to: "part_c_standard_deviation", type: "enables", strength: 9 },
          { from: "part_a_calculation", to: "final_answers", type: "contributes_to", strength: 8 },
          { from: "part_b_maximum_s", to: "final_answers", type: "contributes_to", strength: 8 },
          { from: "part_c_standard_deviation", to: "final_answers", type: "contributes_to", strength: 9 }
        ]
      }
    }
  ],
  
  polynomials: [
    {
      id: 'hkdse2025_polynomials_01',
      problem: "设 $f(x) = 2x^3 + hx^2 + kx + 15$，其中 $h$ 及 $k$ 均为常数。当 $f(x)$ 除以 $x+2$ 时，余数为 $-45$。已知 $f(x)$ 可被 $2x-5$ 整除。(a) 求 $h$ 及 $k$。(b) 某人宣称方程 $f(x) = 0$ 所有的根均为有理数。你是否同意？试解释你的答案。",
      problemType: "polynomials_remainder_factor_theorem",
      difficulty: "intermediate",
      description: "Working with polynomial division and factor theorem",
      graphData: {
        nodes: [
          {
            id: "polynomial_structure",
            name: "Polynomial Structure",
            type: "concepts",
            description: "f(x) = 2x³ + hx² + kx + 15",
            value: "Cubic polynomial with unknown coefficients",
            importance: 10,
            x: 0, y: -200, z: 0
          },
          {
            id: "remainder_theorem",
            name: "Remainder Theorem",
            type: "concepts",
            description: "When f(x) divided by (x+2), remainder is f(-2)",
            value: "f(-2) = -45",
            importance: 9,
            x: -200, y: 0, z: 0
          },
          {
            id: "factor_theorem",
            name: "Factor Theorem",
            type: "concepts",
            description: "If (2x-5) is a factor, then f(5/2) = 0",
            value: "f(5/2) = 0",
            importance: 9,
            x: 200, y: 0, z: 0
          },
          {
            id: "step1_equation1",
            name: "Step 1: First Equation",
            type: "steps",
            description: "Substitute x = -2 into f(x)",
            value: "f(-2) = -16 + 4h - 2k + 15 = -45",
            importance: 8,
            x: 0, y: 100, z: 0
          },
          {
            id: "step2_equation2",
            name: "Step 2: Second Equation",
            type: "steps",
            description: "Substitute x = 5/2 into f(x)",
            value: "f(5/2) = 125/4 + 25h/4 + 5k/2 + 15 = 0",
            importance: 8,
            x: 0, y: 150, z: 0
          },
          {
            id: "step3_solve_system",
            name: "Step 3: Solve System",
            type: "steps",
            description: "Solve the system of equations",
            value: "4h - 2k = -44, 25h + 10k = -185",
            importance: 9,
            x: 0, y: 200, z: 0
          },
          {
            id: "part_b_rational_roots",
            name: "Part (b): Rational Roots",
            type: "steps",
            description: "Check if all roots are rational",
            value: "Use rational root theorem",
            importance: 8,
            x: -200, y: 200, z: 0
          },
          {
            id: "final_answers",
            name: "Final Answers",
            type: "values",
            description: "Values of h, k and conclusion about roots",
            value: "(a) h = -3, k = -16 (b) Yes/No with explanation",
            importance: 10,
            x: 0, y: 300, z: 0
          }
        ],
        links: [
          { from: "polynomial_structure", to: "step1_equation1", type: "enables", strength: 9 },
          { from: "remainder_theorem", to: "step1_equation1", type: "enables", strength: 9 },
          { from: "factor_theorem", to: "step2_equation2", type: "enables", strength: 9 },
          { from: "step1_equation1", to: "step3_solve_system", type: "leads_to", strength: 9 },
          { from: "step2_equation2", to: "step3_solve_system", type: "leads_to", strength: 9 },
          { from: "step3_solve_system", to: "part_b_rational_roots", type: "enables", strength: 8 },
          { from: "step3_solve_system", to: "final_answers", type: "contributes_to", strength: 9 },
          { from: "part_b_rational_roots", to: "final_answers", type: "contributes_to", strength: 8 }
        ]
      }
    }
  ]
}; 